/* eslint-disable no-undef */
import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Modal, TextInput, Button, Checkbox } from 'advenio-components'
import { Form as OriginalForm } from 'formsy-react' // eslint-disable-line
import { isValidCardNumber, isValidExpirationDate, isValidCVV } from './Validations'
import ErrorIsland from '../ErrorIsland'

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #cecece;
`
const CloseModal = styled.div`
  margin: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 20px;
  }
`
const ModalContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  flex-direction: row;
  flex-wrap: wrap;
  @media (max-width: 763px) {
    display: block;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
`
const Form = styled(OriginalForm)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
const InputRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  flex-wrap: wrap;
  @media (max-width: 763px) {
    flex-direction: column;
  }
`
const InputContainer = styled.div`
  width: 200px;
  margin: 0 16px 0 16px;
  ${props => props.hide && 'display: none'}
`
const InputContainerSmall = styled.div`
  width: 80px;
  margin: 0 8px 0 0px;
`
const FormContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  width: 500px;
  @media (max-width: 763px) {
    flex-direction: column;
  }
`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  @media (max-width: 763px) {
    justify-content: center;
  }
`
const DateContainer = styled.div`
  margin-left: 16px;
  display: flex;
  align-items: center;
  span{
    margin-right: 8px;
  }
`
const ErrorContainer = styled.div`
  color: red;
  font-size: 14px;
  max-width: 160px;
  padding-left: 16px;
  margin-bottom: 8px;
`

class CreateCardModal extends Component {
  state = {
    errorDate: false,
    sendDisable: true,
    width: 0,
    errorFromCardToken: false,
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps = ({ errorAfterCreate }) => {
    if (errorAfterCreate) {
      this.setState({ errorFromCardToken: errorAfterCreate.error })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  onSubmit = (cardInfo) => {
    const { onCardCreate } = this.props
    if (!this.state.errorDate) {
      this.createCard(cardInfo)
      this.setState({ errorFromCardToken: false })
    }
  }

  onSuccess = (providerResponse, default_card) => {
    const { provider, sendCard } = this.props
    let token = ''

    if (provider === 'SrPago') {
      token = providerResponse.token
    } else {
      token = providerResponse.id
    }

    const card_info = { token, default: default_card, payment_provider: provider }
    sendCard(card_info)
  }

  onError = ({ description, message }) => {
    this.setState({ errorFromCardToken: description || message, sendDisable: true })
  }

  onCardCreateFail = error => this.onError(error)

  onCardCreateSuccess = default_card => (providerResponse) => {
    this.onSuccess(providerResponse, default_card)
  }

  validateDate = ({ exp_month, exp_year }) => {
    if (exp_month && exp_year) {
      this.setState({
        errorDate: !isValidExpirationDate(exp_month, exp_year, this.props.provider) ? 'Fecha Inválida' : false })
    } else {
      this.setState({ errorDate: true })
    }
  }

  validateForm = () => {
    const { errorDate } = this.state
    this.setState({ sendDisable: !!errorDate })
  }

  invalidateForm = () => {
    this.setState({ sendDisable: true })
  }

  createCard = ({ exp_month, exp_year, ...rest }) => {
    if (this.props.provider === 'SrPago') {
      const payload = {
        exp_month,
        exp_year,
        ...rest,
      }

      return SrPago.token.create(
        payload,
        this.onCardCreateSuccess(rest.default_card),
        this.onCardCreateFail,
      )
    }

    const payload = {
      card: {
        exp_month,
        exp_year,
        name: rest.holder_name,
        number: rest.number,
        cvc: rest.cvv,
      },
    }

    return Conekta.Token.create(
      payload,
      this.onCardCreateSuccess(rest.default_card),
      this.onCardCreateFail,
    )
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  requiredField = (e) => {
    if (e.currentTarget.value.length === 0) {
      this.setState({ errorDate: 'Campos obligatorios' })
    }
  }

  beforeClose = () => {
    this.setState({
      errorDate: false,
      sendDisable: true,
      errorFromCardToken: false,
    }, this.props.onClose)
  }

  render() {
    const { open, onClose, parent, provider, card, loading, forceDefault } = this.props
    const { errorDate, sendDisable, errorFromCardToken, width } = this.state

    return (
      <Modal
        full={width < 763}
        isOpened={open}
        onClose={this.beforeClose}
        statePath="cards"
        actionType="create"
        typePrefix="CARDS"
      >
        <ModalHeader>
          <h2>Agregar Tarjeta</h2>
          <CloseModal onClick={this.beforeClose}>
            <img src="/assets/Close.svg" alt="close" />
          </CloseModal>
        </ModalHeader>
        <ModalContent>
          <Form
            onChange={this.validateDate}
            onValidSubmit={this.onSubmit}
            onValid={this.validateForm}
            onInvalid={this.invalidateForm}
          >
            {!!errorFromCardToken && <ErrorIsland error={errorFromCardToken} />}
            <FormContainer>
              <InputRow>
                <InputContainer hide>
                  <TextInput
                    name="payment_provider"
                    label="Payment Provider"
                    value={provider}
                    type="hidden"
                  />
                </InputContainer>
                <InputContainer>
                  <TextInput
                    name="holder_name"
                    label="Nombre de Tarjetahabiente"
                    value={parent && parent.name}
                    valid={false}
                    required
                  />
                </InputContainer>
                <InputContainer>
                  <TextInput
                    name="number"
                    required
                    label="Numero de tarjeta"
                    validations={{
                      customValidation: isValidCardNumber,
                    }}
                    validationErrors={{
                      customValidation: 'Número de tarjeta inválido',
                    }}
                  />
                </InputContainer>
              </InputRow>
              <InputRow>
                <InputContainer>
                  <TextInput
                    name="cvv"
                    label="CVV"
                    required
                    type="number"
                    validations={{
                      maxLength: 4,
                      customValidation: isValidCVV,
                    }}
                    validationErrors={{
                      maxLength: 'Código Inválido',
                      customValidation: 'Código Inválido',
                    }}
                  />
                </InputContainer>
                <div>
                  <DateContainer>
                    <InputContainerSmall>
                      <TextInput
                        name="exp_month"
                        label="MM"
                        hideEmptyHelpBlock
                        type="number"
                        onChangeCallback={this.requiredField}
                      />
                    </InputContainerSmall>
                    <InputContainerSmall>
                      <TextInput
                        name="exp_year"
                        label={provider === 'Conekta' ? 'YYYY' : 'YY'}
                        hideEmptyHelpBlock
                        type="number"
                        onChangeCallback={this.requiredField}
                      />
                    </InputContainerSmall>
                  </DateContainer>
                  <ErrorContainer>
                    {errorDate && errorDate}
                  </ErrorContainer>
                </div>
                <InputContainer>
                  <Checkbox
                    name="default_card"
                    label="¿Usar por default?"
                    value={forceDefault}
                    disabled={forceDefault}
                  />
                </InputContainer>
              </InputRow>
            </FormContainer>
            <ButtonsContainer>
              <Button
                onClick={this.beforeClose}
              >
                Cancelar
              </Button>
              <Button
                primary
                type="sumbit"
                disabled={sendDisable}
                loading={loading}
              >
                Agregar
              </Button>
            </ButtonsContainer>
          </Form>
        </ModalContent>
      </Modal>
    )
  }
}

CreateCardModal.propTypes = {
  /** The name of the payment provider being used */
  provider: PropTypes.string.isRequired,
  /** Callback function to send the card details to the API */
  sendCard: PropTypes.func.isRequired,
}

export default CreateCardModal



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/CreateCardModal.jsx